import "./Faq01.css";

import React, { useState } from "react";

function Faq01() {
  const [activeIndex, setActiveIndex] = useState(0);

  const faqs = [
    {
      question: "Where is Razor King located in Waterloo and Kitchener?",
      answer:
        "Razor King has two barbershops in Waterloo, ON, and a brand-new third location in Kitchener, ON. You can find addresses and contact information for each location on our website's 'Locations' page.",
    },
    {
      question: "What are the hours of operation for Razor King barbershops?",
      answer:
        "Our hours are the same for all locations. Mon-Fri: 10:00AM - 8:00PM, Sat: 10:00AM - 7:00PM, Sun: 11:00AM - 5:00PM",
    },
    {
      question: "How much does a haircut cost at Razor King?",
      answer:
        'Our pricing for a master haircut starts at a competitive rate and may vary depending on the service and barber. For a full list of prices for all our services, please visit our "Services" page.',
    },
    {
      question:
        "Do you take walk-ins at your barbershops in Waterloo or Kitchener?",
      answer:
        "While we do accept walk-ins when a barber is available, we highly recommend booking an appointment online to guarantee your spot and minimize waiting time.",
    },
    {
      question: "What is the difference between a skin fade and a taper?",
      answer:
        "A skin fade blends the hair down to the skin at the bottom, creating a smooth transition from hair to skin. A taper, however, leaves a short amount of hair at the bottom, creating a less dramatic gradient that still looks sharp and clean. Our expert barbers specialize in both.",
    },
    {
      question: "How often should I get a haircut to maintain my style?",
      answer:
        "The ideal frequency depends on your desired style and hair type. For a tight, clean look like a fade, we recommend a visit every 1-2 weeks. For longer or classic styles, every 3-4 weeks is sufficient to maintain shape and manage split ends.",
    },
    {
      question: "How should I properly care for my beard at home?",
      answer:
        "Proper beard care involves a consistent routine. We recommend using a quality beard wash 2-3 times per week, applying beard oil daily for moisture, and using a beard balm to style and tame any unruly hairs. A high-quality beard brush is also essential for distribution and shaping.",
    },
    {
      question: "Can I get a hot towel shave at Razor King?",
      answer:
        "Yes, a classic hot towel shave is one of our signature services. Our barbers use traditional techniques to provide a close, comfortable shave that leaves your skin feeling smooth and refreshed.",
    },
    {
      question: "Do you offer beard grooming and beard trimming services?",
      answer:
        "We offer a full range of beard services, including beard trims, shaping, and full beard grooming with hot towels and premium products. Our barbers are experts in crafting and maintaining all beard styles.",
    },
  ];

  const toggleAnswer = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  return (
    <div className="Faq01 section" id="Faq01">
      <div className="container">
        <div className="intro">
          <p className="eyebrow">FAQs</p>
          <h2>Frequently Asked Questions.</h2>
          <p>And other things, that we think you should know.</p>
        </div>
        <div className="Faq01-box">
          {faqs.map((faq, index) => (
            <div key={index} onClick={() => toggleAnswer(index)}>
              <h3>{faq.question}</h3>
              {activeIndex === index && <p className="answer">{faq.answer}</p>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Faq01;
